import React from 'react';
import { TooltipDefinition, Button } from 'carbon-components-react';
import { Launch16, Maximize16 } from '@carbon/icons-react';
import WebMapViewer from 'components/WebMap';
import { useDeviceType } from 'customHooks/useDeviceType';

interface OpenLookUpAndLiveButtonProps {
  isLoading: boolean;
  onOpenLual: () => void;
}

export const OpenLookUpAndLiveButton = ({
  onOpenLual
}: OpenLookUpAndLiveButtonProps) => {
  const { isMobileOrTablet } = useDeviceType();

  return isMobileOrTablet ? (
    <div>
      <Button
        kind={'secondary'}
        className="open-in-lual-button"
        renderIcon={Launch16}
        onClick={onOpenLual}
        style={{ width: '12rem', height: '2.5rem', minHeight: 'unset' }}
      >
        View on LUAL
      </Button>
    </div>
  ) : (
    <TooltipDefinition
      tooltipText={
        'Open the Look up and Live application for your enquiry area in a new tab'
      }
      direction="bottom"
      align="center"
      className="open-in-lual-tooltip"
    >
      <Button
        kind={'secondary'}
        className="open-in-lual-button"
        renderIcon={Launch16}
        onClick={onOpenLual}
      >
        View on LUAL
      </Button>
    </TooltipDefinition>
  );
};

interface LookUpAndLiveContentProps {
  extent: any;
  enquiryShape?: any;
  onOpenLual: () => void;
  onExpandLual: () => void;
  onLualMapZoomChange?: (zoomLevel: number) => void;
}

const LookUpAndLiveContent = ({
  extent,
  enquiryShape,
  onOpenLual,
  onExpandLual,
  onLualMapZoomChange
}: LookUpAndLiveContentProps) => {
  const { isMobileOrTablet } = useDeviceType();

  return isMobileOrTablet ? (
    <div className="lual-content" data-testid="lual-content">
      <div className="lual-container" style={{ padding: '0px' }}>
        <div className="map--view lual-map-container" data-testid="lual-map">
          <WebMapViewer
            portalItem={{
              id: '2ef48ad879b6488e9239298dd45f71ed'
            }}
            extent={extent}
            enquiryShape={enquiryShape}
            showCurrentLocationButton={true}
            showHomeButton={true}
          />
        </div>
      </div>
    </div>
  ) : (
    <div className="lual-content" data-testid="lual-content">
      <div className="lual-container">
        <div className="lual-header">
          <div className="lual-header-section">
            <div className="lual-header-section-mobile">
              <div className="lual-header-section-logo">
                <img src="../lual-logo.png" alt="LUAL" />
              </div>
              <div
                className="icon-circle lual-expand-button-mobile"
                onClick={onExpandLual}
                data-testid="lual-expand-button"
              >
                <Maximize16 />
              </div>
            </div>
            <div className="lual-header-section-text">
              View your job site on Look up and Live (LUAL) to check for
              above-ground assets such as powerlines and other infrastructure.
            </div>
          </div>
          <div className="lual-header-section">
            <div className="lual-header-section-action">
              <OpenLookUpAndLiveButton
                isLoading={false}
                onOpenLual={onOpenLual}
                data-testid="open-in-lual-button"
              />
              <div
                className="icon-circle lual-expand-button"
                onClick={onExpandLual}
                data-testid="lual-expand-button"
              >
                <Maximize16 />
              </div>
            </div>
          </div>
        </div>
        <div className="map--view lual-map-container" data-testid="lual-map">
          <WebMapViewer
            portalItem={{
              id: '2ef48ad879b6488e9239298dd45f71ed'
            }}
            extent={extent}
            enquiryShape={enquiryShape}
            showCurrentLocationButton={true}
            showHomeButton={true}
            onZoomChange={onLualMapZoomChange}
          />
        </div>
      </div>
    </div>
  );
};
export default LookUpAndLiveContent;
